import { useEffect, useState } from "react";

// lib
import { Firestore } from "lib/firebase";

// components
import { DisplayDate } from "shared/pipes/display-date";


const History = ({ customer }) => {

    const [data, setData] = useState([]);

    useEffect(() => {
        const getHistory = async () => {
            const res = await Firestore.collection('users')
                .doc(customer.id)
                .collection('history')
                .orderBy('timestamp', 'desc')
                .limit(10)
                .get();

            setData(res.docs.map(
                (d) => d.data())
            );
        }

        getHistory();
    }, [customer]);

    if (!data.length) {
        return (
            <article className="message p-6 mr-6">
                <div className="message-body">
                    No history for this customer.
                </div>
            </article>
        );
    }

    return (
        <div className="timeline">

            <header className="timeline-header">
                <span className="tag is-medium is-primary">Latest</span>
            </header>

            {data.map((change) => (
                <div key={change.timestamp} className="timeline-item">
                    <div className="timeline-marker"></div>

                    <div className="timeline-content">
                        <p className="heading">
                            <DisplayDate>
                                {change.timestamp}
                            </DisplayDate>

                            <small className="ml-6">Tidie</small>
                        </p>

                        <div className="columns is-multiline">
                            {Object.keys(change.changes).map((key) => (
                                <div className="column has-background-light m-3">
                                    <p><b>{key}</b></p>
                                    <p>{change.changes[key].new}</p>
                                    <p>
                                        <strike>{change.changes[key].old || 'None'}</strike>
                                    </p>
                                    <br />
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            ))}

            <div className="timeline-header">
                <span className="tag is-medium is-primary">Old</span>
            </div>

        </div>
    );
}

export { History };
